/**
 * Calculate CRF scope scores
 * @param {Object} categorizedScoresObj - Categorized scores object
 * @param {Object} qualityItems - Quality items structure
 */
(function($) {
	function crfScope(categorizedScoresObj, qualityItems) {
		console.log('[crfScope] Starting function with categorizedScoresObj:', categorizedScoresObj);
		
		// Extract the cleaned categorized scores from the object returned by calculateMaturityScoresByLevelPerCategory
		const categorizedScores = categorizedScoresObj.cleanedCategorizedScores || categorizedScoresObj;
		console.log('[crfScope] Extracted categorizedScores:', categorizedScores);
		
		// Check if we're in legacy mode by looking at the selected dashboard
		const isLegacyMode = $('.dashboard-selection').val() === 'CRFS-LEGACY';
		console.log('[crfScope] Is legacy mode:', isLegacyMode);
		
		// Function to calculate average maturity score from a category's topics
		function calculateCategoryAverage(categoryScores) {
			console.log('[crfScope.calculateCategoryAverage] Starting calculation with categoryScores:', categoryScores);
			if (!categoryScores) {
				console.log('[crfScope.calculateCategoryAverage] No category scores provided, returning 0.00');
				return "0.00";
			}

			let totalScore = 0;
			let totalPotentialItems = 0;
			let totalNAItems = 0;

			// Iterate over all topics in the category
			Object.keys(categoryScores).forEach(topicName => {
				if (topicName === 'overallMaturityScore') return; // Skip non-topic properties
				
				const topic = categoryScores[topicName];
				if (typeof topic !== 'object') return;

				// Iterate over all priorities in the topic
				Object.keys(topic).forEach(priorityName => {
					if (priorityName === 'overallMaturityScore') return; // Skip non-priority properties

					const priorityData = topic[priorityName];
					if (typeof priorityData === 'object') {
						totalScore += priorityData.totalScore || 0;
						totalPotentialItems += priorityData.potentialCount || 0;
						totalNAItems += priorityData.naItems ? priorityData.naItems.length : 0;
					}
				});
			});

			const denominator = totalPotentialItems - totalNAItems;
			let result = 'N/A';
			if (denominator > 0) {
				// The average raw score is the sum of scores from answered items divided
				// by the total number of applicable items (answered or not).
				const avg = totalScore / denominator;
				result = (avg * 5).toFixed(2); // Scale to 5-point
			}
			console.log(`[crfScope.calculateCategoryAverage] totalScore: ${totalScore}, denominator (potential - NA): ${denominator}, totalPotentialItems: ${totalPotentialItems}, totalNAItems: ${totalNAItems}, result: ${result}`);
			return result;
		}

		// For legacy mode, we need to reorganize the data based on the topic orders from controls file
		if (isLegacyMode) {
			console.log('[crfScope] Using legacy topic organization');
			
			// Define the topic categories based on the topicOrder in web-assessment-controls-crfs2021.js
			const legacyTopicCategories = {
				'Governance': [
					'Governance',
					'Threat Management',
					'Security Policy Management',
					'Education and Awareness',
					'Project Management',
					'Exception Management',
					'Metrics Management',
					'Audit Management',
					'Third Party Management',
					'Risk Reporting',
					'Personnel Management',
					'Physical Security',
					'Business Continuity',
					'Incident Management',
					'Data Privacy'
				],
				'Technical': [
					'Asset Inventory',
					'Software Inventory',
					'Application Control',
					'Patch Management',
					'Vulnerability Management',
					'Configuration Management',
					'Endpoint Protection',
					'Removable Media Protection',
					'Mobile Device Protection',
					'Backup and Recovery',
					'Log Management',
					'File Integrity Management',
					'Identity Management',
					'Data Inventory',
					'Access Management',
					'Privileged Account Management',
					'Network Device Management',
					'Boundary Filtering',
					'Remote Access',
					'Web Filtering',
					'Email Filtering',
					'Network Segmentation',
					'Wireless',
					'Software Development',
					'Static Code Analysis'
				]
			};
			
			// Create a mapping of topics to their legacy categories
			const topicToCategoryMap = {};
			Object.keys(legacyTopicCategories).forEach(category => {
				legacyTopicCategories[category].forEach(topic => {
					topicToCategoryMap[topic] = category;
				});
			});
			
			// Reorganize the categorizedScores based on legacy categories
			const legacyCategorizedScores = {
				'Governance': {},
				'Technical': {}
			};
			
			// Iterate through all topics in the original categorizedScores and move them to the appropriate legacy category
			Object.keys(categorizedScores).forEach(originalCategory => {
				Object.keys(categorizedScores[originalCategory]).forEach(topic => {
					if (topic === 'overallMaturityScore') return;
					
					// Find which legacy category this topic belongs to
					const legacyCategory = topicToCategoryMap[topic];
					if (legacyCategory) {
						legacyCategorizedScores[legacyCategory][topic] = categorizedScores[originalCategory][topic];
					} else {
						console.log(`[crfScope] Topic not found in legacy categories: ${topic}`);
					}
				});
			});
			
			// Calculate overall maturity scores for each legacy category
			Object.keys(legacyCategorizedScores).forEach(category => {
				legacyCategorizedScores[category].overallMaturityScore = calculateCategoryAverage(legacyCategorizedScores[category]);
			});
			
			console.log('[crfScope] Reorganized scores for legacy mode:', legacyCategorizedScores);
			
			// Calculate values for each legacy category
			let governanceValue = calculateCategoryAverage(legacyCategorizedScores["Governance"]);
			let technicalValue = calculateCategoryAverage(legacyCategorizedScores["Technical"]);
			
			// Calculate the overall average of all category averages, excluding "N/A" values
			let values = [governanceValue, technicalValue].filter(v => v !== "0.00" && v !== "N/A");
			console.log('[crfScope] Filtered values for overall calculation:', values);
			
			let overallValue = values.reduce((acc, v) => acc + parseFloat(v), 0) / values.length;
			overallValue = overallValue.toFixed(2);
			console.log('[crfScope] Calculated overall value:', overallValue);
			
			// Map legacy topics to their corresponding selectors in the HTML
			const topicToSelectorMap = {
				'Governance': 'governance',
				'Threat Management': 'threat',
				'Security Policy Management': 'policy',
				'Education and Awareness': 'education',
				'Project Management': 'project',
				'Exception Management': 'change',
				'Metrics Management': 'metrics',
				'Audit Management': 'audit',
				'Third Party Management': 'thirdparty',
				'Risk Reporting': 'risk',
				'Personnel Management': 'personnel',
				'Physical Security': 'physical',
				'Business Continuity': 'continuity',
				'Incident Management': 'incident',
				'Data Privacy': 'privacy'
			};
			
			// Update the DOM with governance values
			Object.keys(topicToSelectorMap).forEach(topic => {
				const selector = `.crf-scope-${topicToSelectorMap[topic]}`;
				let value = "0.00";
				
				if (legacyCategorizedScores["Governance"][topic]) {
					const topicData = legacyCategorizedScores["Governance"][topic];
					
					// Calculate total NA items and potential items for this topic
					let topicNAItems = 0;
					let topicPotentialItems = 0;
					
					Object.keys(topicData).forEach(priority => {
						if (priority !== 'overallMaturityScore') {
							topicNAItems += topicData[priority].naItems ? topicData[priority].naItems.length : 0;
							topicPotentialItems += topicData[priority].potentialCount || 0;
						}
					});
					
					// If all items are NA, hide the row
					if (topicNAItems >= topicPotentialItems && topicPotentialItems > 0) {
						console.log(`[crfScope] Hiding row for topic ${topic} - all items are NA (${topicNAItems}/${topicPotentialItems})`);
						console.log(`[crfScope] Hiding selector: ${selector}`);
						$(selector).closest('tr').hide();
						return;
					}
					
					const denominator = Object.keys(topicData)
						.filter(k => k !== 'overallMaturityScore')
						.reduce((acc, priority) => {
							return acc + topicData[priority].potentialCount - topicData[priority].naItems.length;
						}, 0);
					
					if (denominator > 0) {
						const totalScore = Object.keys(topicData)
							.filter(k => k !== 'overallMaturityScore')
							.reduce((acc, priority) => acc + topicData[priority].totalScore, 0);
						value = ((totalScore / denominator) * 5).toFixed(2);
					}
				}
				
				$(selector).text(value);
			});
			
			// Set the overall values
			$('.crf-scope-overall').text(overallValue);
			
			console.log('[crfScope] Legacy function completed successfully');
		} else {
		console.log('[crfScope] Calculating values for each standard category...');
		let governanceValue = calculateCategoryAverage(categorizedScores["Cybersecurity Governance"]);
		let operationsValue = calculateCategoryAverage(categorizedScores["Operational Cybersecurity"]);
		let identityValue = calculateCategoryAverage(categorizedScores["Identity and Access Cybersecurity"]);
		let endpointsValue = calculateCategoryAverage(categorizedScores["Computing System Cybersecurity"]);
		let networkValue = calculateCategoryAverage(categorizedScores["Network Cybersecurity"]);
		let cloudValue = calculateCategoryAverage(categorizedScores["Cloud Cybersecurity"]);
		let developmentValue = calculateCategoryAverage(categorizedScores["Development Cybersecurity"]);

		console.log('[crfScope] Category values calculated:', {
			governanceValue,
			operationsValue,
			identityValue,
			endpointsValue,
			networkValue,
			cloudValue,
			developmentValue
		});

		// Calculate the overall average of all category averages, excluding "N/A" values
		let values = [governanceValue, operationsValue, identityValue, networkValue, cloudValue, developmentValue]
			.filter(v => v !== "0.00" && v !== "N/A");
		console.log('[crfScope] Filtered values for overall calculation:', values);
		
		let overallValue = values.reduce((acc, v) => acc + parseFloat(v), 0) / values.length;
		overallValue = overallValue.toFixed(2);
		console.log('[crfScope] Calculated overall value:', overallValue);

		// Set values and hide N/A rows so the chart doesn't render empty bars
		console.log('[crfScope] Setting values in DOM...');
		var scopeEntries = [
			{ sel: '.crf-scope-governance', val: governanceValue },
			{ sel: '.crf-scope-operations', val: operationsValue },
			{ sel: '.crf-scope-identity', val: identityValue },
			{ sel: '.crf-scope-endpoints', val: endpointsValue },
			{ sel: '.crf-scope-network', val: networkValue },
			{ sel: '.crf-scope-cloud', val: cloudValue },
			{ sel: '.crf-scope-development', val: developmentValue }
		];
		scopeEntries.forEach(function(entry) {
			$(entry.sel).text(entry.val);
			if (entry.val === 'N/A') {
				$(entry.sel).closest('tr').addClass('scope-all-na').hide();
			} else {
				$(entry.sel).closest('tr').removeClass('scope-all-na').show();
			}
		});
		$('.crf-scope-overall').text(overallValue);
		
		console.log('[crfScope] Function completed successfully');
		}
	}

	// Export for use in other modules
	if (typeof module !== 'undefined' && module.exports) {
		module.exports = crfScope;
	} else if (typeof window !== 'undefined') {
		window.crfScope = crfScope;
	}

})(jQuery);
